import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import BasicTooltip from 'components/BasicTooltip';

import LinkButton from 'components/LinkButton';
import { ROUTE_REGEXP } from 'constants/route';

const ApplicationWidgetItem = props => {
  const { record, isJob } = props;
  const {
    FirmName,
    FirmTitle,
    FirmActive,
    DateApply,
    PositionTitle,
    ProcessID,
    HasReceivedInterview,
    HasConfirmedInterest,
  } = record;

  const link = useMemo(() => {
    const positionLink = ROUTE_REGEXP.SEARCH_VIEW_APPLICANTS.replace(
      ':type(process|project)',
      isJob ? 'process' : 'project'
    ).replace(':id(\\d+)', ProcessID);

    if (FirmActive === 'Yes') {
      return (
        <LinkButton
          target="_blank"
          text={FirmName}
          link={positionLink}
          btnFontWeight="600"
          btnFontSize="0.8571rem"
          underline={false}
          btnFontFamily="Noto Sans"
          btnTextColor={
            HasReceivedInterview || HasConfirmedInterest ? '#f40' : null
          }
        />
      );
    }

    return (
      <>
        <span
          className="sidebar__text"
          style={{
            fontFamily: 'Noto Sans", sans-serif',
            fontWeight: 600,
            fontSize: '0.8571rem',
            color:
              HasReceivedInterview || HasConfirmedInterest ? '#f40' : '#17377d',
          }}
        >
          {record.FirmName}
        </span>{' '}
      </>
    );
  }, []);

  return (
    <div className="sidebar__table-row">
      <BasicTooltip tooltip={FirmTitle}>
        <div
          className="sidebar__table-column"
          style={{
            flex: '1 1 175px',
          }}
        >
          <div
            className="sidebar__text"
            style={{
              display: 'inline',
              fontSize: '0.8571rem',
            }}
          >
            {link}, <span className="sidebar__text">{PositionTitle}</span>
          </div>
        </div>
        <div
          className="sidebar__table-column"
          style={{
            flex: '1 0 72px',
            marginRight: 0,
          }}
        >
          <div className="sidebar__text">{DateApply}</div>
        </div>
      </BasicTooltip>
    </div>
  );
};

ApplicationWidgetItem.propTypes = {
  record: PropTypes.object.isRequired,
  isProject: props =>
    !props.isJob && !props.isProject
      ? new Error(
          `One of props 'isProject' or 'isJob' was not specified in 'ApplicationWidgetItem'.`
        )
      : null,
  isJob: props =>
    !props.isJob && !props.isProject
      ? new Error(
          `One of props 'isProject' or 'isJob' was not specified in 'ApplicationWidgetItem'.`
        )
      : null,
};

export default ApplicationWidgetItem;
